var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallOngoing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.12 9.13C36 10.3 35 9.9 35 8.25V3a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v24a3 3 0 0 0 3 3h29a3 3 0 0 0 3-3v-5.25c0-1.65 1-2 2.12-.88l5.76 5.76c1.17 1.17 2.12.77 2.12-.88V4.25c0-1.65-1-2-2.12-.88Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 9,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#008625"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "fill",
    values: "#008625;transparent;#008625",
    dur: "2s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallOngoing);
export default __webpack_public_path__ + "static/media/call-ongoing.a590c968e914b306e207c45c010e6e30.svg";
export { ForwardRef as ReactComponent };